import { MatButtonModule } from '@angular/material/button';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Tarea, TareasResponse } from 'app/models/tareas.model';
import { TablaGestionesComponent } from './tabla-gestiones/tabla-gestiones.component';
import { environment as env } from 'environments/environments';
import { GestionesService } from './gestiones.service';
import { UserService } from 'app/core/user/user.service';
import { CardContadorComponent } from 'app/modules/GlobalComponents/card-contador';
import { TotalGestionesInterface } from 'app/models/totalesGestionesModel';
import { MatDialog } from '@angular/material/dialog';
import { FormGestionComponent } from './form-gestion/form-gestion.component';
import moment from 'moment';
import { Observable, Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { UtilsService } from 'app/modules/utils-service';
import { navegacionTareas } from 'app/models/datos-navegacion-solicitudes-gestiones';
import { Router } from '@angular/router';
import { ArrowBackComponent } from 'app/modules/GlobalComponents/arrow-back.component';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';

@Component({
    selector: 'gestiones',
    templateUrl: 'gestiones.component.html',
    imports:[
        MatIconModule,
        MatMenuModule,
        MatButtonModule,
        CommonModule,
        MatPaginatorModule,

        //componentes
        TablaGestionesComponent,
        CardContadorComponent,
        ArrowBackComponent

    ]
})

export class GestionesComponent implements OnInit {
    dataSource: Tarea[]
    dataSource$: Observable<TareasResponse>

    tipologiaIdGestiones:number
    totalGestiones$: Observable<TotalGestionesInterface>
    @ViewChild(MatPaginator) paginator: MatPaginator;
    _unsubscribe: Subject<any> = new Subject()
    inicio:number = 0
    max:number = 10
    pageSize:number=10

    public TODAYS_DATE= env.TODAYS_DATE
    public TODAYS_DEADLINE = `${moment().format('YYYY-MM-DD').toString()} 23:59`;
    public TREE_MONTHS_AGO= `${moment().subtract(3, 'months').format('YYYY-MM-DD').toString()} 00:00`; 
    public SIX_MONTHS_AGO= `${moment().subtract(6, 'months').format('YYYY-MM-DD').toString()} 00:00`; 

    titulo:string= 'Mis Gestiones'
    private _destroy$ = new Subject<void>(); 
    
    constructor(
        private _gestionesService: GestionesService,
        private _userService: UserService,
        public dialog: MatDialog,
        private utilsService:UtilsService,
        private router: Router
    ) {
        
        this.tipologiaIdGestiones=env.TIPOLOGIA_ID_GESTIONES
        
    }

    ngOnInit() {
        this.dataSource$ = this._gestionesService.gestiones$;
        this.totalGestiones$ = this._gestionesService.totalGestiones$;
    
        const url = this.router.url;
    
        this.dataSource$.pipe(takeUntil(this._destroy$)).subscribe(response => {
            if (url.includes('/gestiones/generales')) {
                this.titulo = 'Gestiones Generales';
            } else {
                const solicitud = navegacionTareas.find(item => item.seccion === this.utilsService.seccion_uuid_value);
                this.titulo = solicitud ? solicitud.titulo : 'Mis gestiones';
            }
        });
    }

    ngAfterViewInit(): void {
        this.paginator.page
            .pipe(takeUntil(this._unsubscribe))
            .subscribe(() => {

                const pageIndex = this.paginator.pageIndex;
                const start = pageIndex * this.pageSize;
                const end = start + this.pageSize;
                
                const currentFilters = this._gestionesService.gestionesFilterParmasValue;
                // Validar si existen filtros 
                if (currentFilters) {
                    // agregar paginación a los filtros
                    const newParams = {
                    ...currentFilters,
                    inicio: start,
                    max: end
                    };

                    this._gestionesService.getAllTasks(newParams);
                } else {
                    // Si no hay filtros, hacer la llamada solo con paginación
                    const newParams = {
                    inicio: start,
                    max: end
                    };

                    this._gestionesService.getAllTasks(newParams);
                }
            });
    }

    getAllTareas(fechaInicio?: string, fechaFin?: string): void {
        const currentFilters = this._gestionesService.gestionesFilterParmasValue;

        // crea nuevo objeto de filtros
        const newFilters: any = {
            ...currentFilters,
            inicio: 0,
            max: this.paginator.pageSize ?? 10
        };

        // Solo agregamos fechas si vienen definidas
        if (fechaInicio) {
            newFilters.fechaInicio = fechaInicio;
        } else {
            delete newFilters.fechaInicio;
        }

        if (fechaFin) {
            newFilters.fechaFin = fechaFin;
        } else {
            delete newFilters.fechaFin;
        }

        // guarda los nuevos filtros en el servicio
        this._gestionesService.setGestionesFilterParams = newFilters;

        this._gestionesService.getAllTasks(newFilters);

        // Reiniciar paginador visualmente
        if (this.paginator) {
            this.paginator.firstPage();
        }
    }
    

    NuevaGestion(){
        const dialog = this.dialog.open(FormGestionComponent, {
                    panelClass: ['w-full', 'md:w-6/12','mx-0'],
                    height: 'calc(100vh - 4rem)',
                    disableClose: true,
                })
    }

    ngOnDestroy() {
        this._destroy$.next(); 
        this._destroy$.complete();
        this._unsubscribe.next(null);
        this._unsubscribe.complete();
    }

}